import React from "react";
import Layout, { LAYOUT_QUERY } from "@/components/Layout";

import { Typography } from "antd";


import { RootState } from "@/store/store";
import { RADIO_STATE } from "@/store/liveRadio/action";
import { connect } from "react-redux";
import { compose } from "redux";
import { fetchAPI } from "@/utils/api/api";
import OnDemand from "@/components/OnDemand";
import "../styles/ondemand.less";

const ONDEMAND_PAGE_QUERY = `
query GetOnDemandPage {
	${LAYOUT_QUERY}
}
`;



const OnDemandPage = ({ graphQLData }) => {

  const data = graphQLData;
  // console.log(errors);
  // if (loading || !data) return <LoadingLayout />;
  // if (!_isEmpty(errors)) return <p>Error: {JSON.stringify(errors)}</p>;


  return (
    <Layout data={data} title={"On Demand"}>
        <OnDemand></OnDemand>
    </Layout>
  );
};

export async function getStaticProps() {
    const data = await fetchAPI(ONDEMAND_PAGE_QUERY);
    return {
      props: {
        graphQLData: data,
      },
      revalidate: 1,
    };
}

const mapState = (state: RootState) => ({
  playing: state.liveRadio.state === RADIO_STATE.PLAYING,
});

const connector = connect(mapState);

export default compose(connector)(OnDemandPage);
